export default __webpack_public_path__ + "media/images/logo/contest/kigyopro-02c0f9fb544e04bdee993d51499613f6.png";